exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticket-event-visible-switch:hover {\n    cursor: pointer;\n    -webkit-box-shadow: 1px 1px 10px 5px #c4c4c4;\n            box-shadow: 1px 1px 10px 5px #c4c4c4;\n    -webkit-transform:scale(1.5);\n            transform:scale(1.5);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bc50f4a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketEventVisibleSwitch.vue
// module id = 1021
// module chunks = 75